import * as React from 'react';

import * as styles from './styles.css';
import { Button, UIHeading2, UIText1 } from '@cian/ui-kit';

interface IReferralsItemModalContentProps {
  isDesktop: boolean;
  title: string;
  description: string;
  btnTxt: string;
  onBtnClick: () => void;
}

export const ReferralsItemModalContent: React.FC<IReferralsItemModalContentProps> = ({
  isDesktop,
  title,
  description,
  btnTxt,
  onBtnClick,
}) => {
  return (
    <div className={styles['modal-content']}>
      <UIHeading2 color="text-primary-default">{title}</UIHeading2>
      <UIText1 color="text-primary-default">{description}</UIText1>

      <Button theme="fill_primary" size="M" onClick={onBtnClick} fullWidth={!isDesktop}>
        {btnTxt}
      </Button>
    </div>
  );
};
